/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Agents_Title_2Inputs */

const en_services_svc_agents_title_2 = /** @type {(inputs: Services_Svc_Agents_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each with a role and a budget.`)
};

const lv_services_svc_agents_title_2 = /** @type {(inputs: Services_Svc_Agents_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katram sava loma un budžets.`)
};

/**
* | output |
* | --- |
* | "Each with a role and a budget." |
*
* @param {Services_Svc_Agents_Title_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_agents_title_2 = /** @type {((inputs?: Services_Svc_Agents_Title_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Agents_Title_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_agents_title_2(inputs)
	return en_services_svc_agents_title_2(inputs)
});